/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import * as ReactDOM from "react-dom";

// Polyfills
import "@babel/polyfill";
import "native-promise-only";
import "whatwg-fetch";

// CSS imports
import "./scss/index.scss";

import App from "./App";

import { Provider } from "react-redux";
import store from "./store";

const el = document.getElementById("root");

const Root = React.createElement(Provider, { store }, React.createElement(App, {}));

if (el != null) {
  ReactDOM.render(Root, el);
} else {
  document.write("Invalid document.");
}

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const HotApp = require("./App");
    ReactDOM.render(React.createElement(HotApp, {}), el);
  });
}
